/** base catch-all case for all newtypes */
export type Newtype<T> = {
    value: T;
    readonly __tag: symbol;
}

export function from<T extends { value: any; readonly __tag: symbol }>(x: T): T['value'] {
    return x as any as T['value'];
}

export function fromArray<T extends { value: any; readonly __tag: symbol }>(x: T[]): Array<T['value']> {
    return x as any as Array<T['value']>;
}

export * from './base64';
export * from './date-string';
export * from './email';
export * from './href';
export * from './id';
